import React from 'react';
import { Footer } from '../Footer/Footer';
import { useEmbedded } from '../../contexts/EmbeddedContext';
import './MainLayout.scss';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { isEmbedded } = useEmbedded();

  return (
    <div className={`main-layout ${isEmbedded ? 'main-layout--embedded' : ''}`}>
      <main className="main-content">{children}</main>
      {!isEmbedded && <Footer />}
    </div>
  );
};
